import Vue from 'vue'
import Router from 'vue-router'
import axios from '../axios'
import store from '../store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: '/',
      redirect: {
        name: 'Index',
      },
      meta: {
        checkLogin: false,
        title: '',
      },
    },
    {
      path: '/index/:id',
      name: 'Index',
      component: () => import('@/views/Index'),
      meta: {
        checkLogin: true,
        title: '',
      },
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import('@/views/Error'),
      meta: {
        checkLogin: false,
        title: '',
      },
    },
    {
      path: '*',
      redirect: { name: "Index" },
    },//全不匹配的情况下，返回到主页，路由按顺序从上到下，依次匹配。最后一个*能匹配全部，
  ]
})

//路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.checkLogin == true) {
    //判断token是否存在
    if (!localStorage.getItem('X-Token')) {
      router.push({
        name: 'Error'
      })
      return false;
    }
  }
  next();
})

router.afterEach((to, from) => {
  //如果登录的话 获取用户信息
  /*if (to.meta.checkLogin) {
    axios.get("/info").then(res => {
      const data = res.data;
      if (data.code == 200) {
        store.state.user = data.data;
      }
    })
  }*/
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js